export default __webpack_public_path__ + "static/media/bg22.87a83667.png";